{
  "it": {
    "pagination": {
      "next": "Pagina successiva",
      "page_report": "Pagina {page} di {total}",
      "previous": "Pagina precedente",
      "report": "Da {first} a {last} di {total}",
      "total": "Elementi totali: {total}"
    }
  }
}
